import { render, staticRenderFns } from "./FilingAFF.vue?vue&type=template&id=190e4446"
import script from "./FilingAFF.vue?vue&type=script&lang=ts"
export * from "./FilingAFF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports